import { TabList } from "@mui/lab";
import { Tab, styled } from "@mui/material"

export const SwiperContainer = styled("div")(({ theme }) => ({
    width: 530,
    display: "flex",
    gap: 10,
    padding: theme.spacing(0, 0),
    borderTop: "2px solid #fff",
    "& .navigate-next": {
        color: "#fff",
        background: "#79797958",
        height: 200,
        width: 250,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderTopLeftRadius: 10,
        borderBottomLeftRadius: 10,
        cursor: "pointer",
    },
    "& .swiper": {
        height: 230,
    },
    "& .swiper-slide": {
        margin: 5,
        "& .MuiCardMedia-root": {
            borderRadius: 20,
            height: 200,
        },
    },
    "& .swiper-pagination": {
        textAlign: "start",
        bottom: 0,
        "& .swiper-pagination-bullet": {
            backgroundColor: "#fff",
        },
        "& .swiper-pagination-bullet-active": {
            width: 80,
            borderRadius: 5,
        },
    },
    [theme.breakpoints.down("md")]: {
        borderTop: "none",
    },
    [theme.breakpoints.down("sm")]: {
        width: "100%",
        padding: 0,
        "& .navigate-next": {
            display: "none",
        },
        "& .swiper": {
            height: 190,
            // width: "95%",
            marginRight: 0,
        },
        "& .swiper-slide": {
            "& .MuiCardMedia-root": {
                borderRadius: 15,
                height: 160,
            },
        },
    },
}));
export const ContentTab = styled(Tab)(({ theme }) => (props) => ({
    backgroundColor: '#FFF',
    color: '#0056D2',
    borderRadius: '10px',
    margin: ' 12px 8px',
    border: '1px solid #DDDDDD ',
    "&.Mui-selected": {
        backgroundColor: '#0056D2',
        color: '#fff',
        borderRadius: '10px',
    },

}))
export const ContentTabList = styled(TabList)(({ theme }) => (props) => ({
    "& .MuiTabs-indicator": {
        display: 'none'
    }
}));
export const ContentSlider = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    padding: '20px 0 10px 0px ',
    [theme.breakpoints.down('md')]: {
        padding: '12px 10px'
    }
}))

export const Card = styled('div')(({ theme }) => (props) => ({
    minWidth: '250px',
    minHeight: '350px',
    width: '300px',
    maxWidth: '300px',
    height: '350px',
    textAlign: 'right',
    padding: '34px',
    border: '2px solid #DDDDDD',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    boxSizing: 'border-box',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
        minWidth: '200px',
        minHeight: '320px',
        width: '200px',
        padding: ' 16px 16px 24px',
    },

    [theme.breakpoints.down('xs')]: {
        minWidth: '180px',
        minHeight: '320px',
        width: '180px',
        padding: ' 16px 16px 24px',
    },
}))
export const ImageCard = styled('div')(({ theme }) => (props) => ({
    maxWidth: '144px',
    maxHeight: '144px',
}))
export const Image = styled('img')(({ theme }) => (props) => ({
    width: '100%',
    height: '100%',
    borderRadius: '5px'
}))
export const TitleCard = styled('h6')(({ theme }) => (props) => ({
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '0em',
    width: '100%',
    textAlign: 'center',
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    margin: '15px 0 8px',
    [theme.breakpoints.down('sm')]: {
        fontSize: '16px',
        fontWeight: 500,
    },
}))
export const TitleDisc = styled('p')(({ theme }) => (props) => ({
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '20px',
    minHeight: "90px",
    maxHeight: '90px',
    letterSpacing: '0em',
    width: '100%',
    textAlign: 'left',
    color: theme.palette.mode === "light" ? theme.palette.text.light : theme.palette.text.dark,
    margin: '0',
    [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
        lineHeight: '1.5',
        minHeight: "80px",
        maxHeight: '80px',

    },
}))
export const Section = styled('div')(({ theme }) => (props) => ({
    padding: '0 96px 0 80px',
    boxSizing: 'border-box',
    overflow: 'hidden',
    borderRadius: theme.shape.bigBorderRadios,
    [theme.breakpoints.down('md')]: {
        width: '100vw',
        padding: '24px 16px'
    },
    [theme.breakpoints.down('sm')]: {
        width: '100vw',
        padding: '16px'
    },

}))
export const Parent = styled('section')(({ theme }) => (props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
}))
export const HeadingText = styled('h4')(({ theme }) => (props) => ({
    fontSize: '24px',
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: '29px',
    letterSpacing: '0em',
    display: 'inline',
    color: theme.palette.mode === 'light' ? theme.palette.text.light : theme.palette.dark,
    [theme.breakpoints.down('md')]: {
        fontSize: '20px'
    }
}))
export const SubHeadingText = styled('h5')(({ theme }) => (props) => ({
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '24px',
    letterSpacing: '0em',
    display: 'inline',
    marginLeft: '10px',
    [theme.breakpoints.down('md')]: {
        fontSize: '16px'
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '14px'
    },
}))
export const SectionRate = styled('div')(({ theme }) => (props) => ({
    display: "Flex",
    alignItems: 'center',
    gap: '8px',
    marginTop: '16px',
    justifyContent: 'right',
    width: '100%'
}))

export const PaginationContainer = styled('div')(({ theme }) => (props) => ({
    position: 'absolute',
    bottom: '0',
    right: '0',
    transform: ' translate(-50%, -50%)',
    width: 'fit-content',
    display: 'none'
}))
